<patron-toolbar>
  <div class="container">
    <div class="flex justify-content-between flex-wrap">
      <div class="flex align-items-center my-2">
        <patron-filter-widget
          [findOptions]="findOptions"
          (onSubmit)="goToFirstPage()"
          #filterWidget></patron-filter-widget>
      </div>
      <div class="my-2">
        <!-- <patron-search-widget (onSearch)="onSearch($event)" #searchWidget></patron-search-widget> -->
      </div>
    </div>
  </div>
</patron-toolbar>

<div class="container">
  <patron-responsive-table
    [headerTemplate]="tableHeader"
    [bodyTemplate]="tableBody"
    [items]="bwUsers"
    [findOptions]="findOptions"
    [loading]="loading">
    <ng-template #tableHeader>
      <tr>
        <th>Nome</th>
        <th>Email</th>
        <th>Cliente</th>
        <th>Origem</th>
        <th class="text-center">Status</th>
        <th style="width: 200px"></th>
      </tr>
    </ng-template>

    <ng-template #tableBody let-item>
      <tr>
        <td>
          <patron-rt-column-title>
            <strong>Nome</strong>
          </patron-rt-column-title>
          <span [innerHTML]="item.bw_user?.name | highlight: findOptions.q!"></span>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Email</strong>
          </patron-rt-column-title>
          <span [innerHTML]="item.bw_user?.email | highlight: findOptions.q!"></span>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Cliente</strong>
          </patron-rt-column-title>
          <span [innerHTML]="item.customer?.person?.name | highlight: findOptions.q!"></span>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Origem</strong>
          </patron-rt-column-title>
          <span [innerHTML]="item.origin | highlight: findOptions.q!"></span>
        </td>
        <td class="text-right lg:text-center">
          <patron-rt-column-title>
            <strong>Status</strong>
          </patron-rt-column-title>
          @if (item.status) {
            <patron-badge
              [color]="
                item.status == 'Recusado'
                  ? 'danger'
                  : item.status == 'Aceito'
                    ? 'success'
                    : 'warning'
              ">
              {{ item.status }}
            </patron-badge>
          }
        </td>
        <td class="text-right">
          <patron-rt-column-title> </patron-rt-column-title>
          @if (item.status) {
            <div>
              @if (item.status != 'Aceito') {
                <patron-button
                  size="sm"
                  iconName="bi-unlock"
                  (click)="changeStatus(item, 'Aceito')"
                  [loading]="loadingBwUser == item.bw_user_id">
                  Aceitar
                </patron-button>
              }
              @if (item.status != 'Recusado') {
                <patron-button
                  size="sm"
                  iconName="bi-lock"
                  (click)="changeStatus(item, 'Recusado')"
                  [loading]="loadingBwUser == item.bw_user_id"
                  color="danger"
                  class="ms-1">
                  Recusar
                </patron-button>
              }
            </div>
          }
        </td>
      </tr>
    </ng-template>
  </patron-responsive-table>
</div>

<patron-toolbar position="bottom" [class.hidden]="!bwUsers.length">
  <patron-paginator
    [totalRecords]="totalItems"
    [findOptions]="findOptions"
    (onPageChange)="paginate($event)"
    #paginator>
  </patron-paginator>
</patron-toolbar>
